// DS: i10.1
import React from 'react';
import IconWrap from '../IconWrap';
const Facebook = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M9.741 20.595v-7.969H7V9.358h2.741V6.614C9.741 4.618 11.385 3 13.413 3h2.865v2.939h-2.05c-.644 0-1.167.514-1.167 1.148v2.271h3.166l-.438 3.268h-2.728v7.97h-3.32z"
    }))));
Facebook.displayName = 'Facebook';
export default Facebook;
